import React from 'react';
import { useIntl } from 'react-intl';

import { Notification } from '@xsolla/ui-core';
import { AlertExclamation } from '@xsolla/ui-icons';

import { EmailProviderFields } from '../../../api';
import { FieldInput } from '../../ui';
import { DescriptionLink, FieldWrapper, ProviderSubtitle, ProviderTitle } from '../style';
import { ProviderFieldsProps } from './types';
import { maxFieldLength } from './validator';

export const SMTPFields = ({ errors }: ProviderFieldsProps): JSX.Element => {
  const intl = useIntl();

  const getError = (field: keyof EmailProviderFields): string => {
    if (errors && errors[field]) {
      return intl.formatMessage(
        { id: errors[field] as string },
        {
          number: maxFieldLength
        }
      );
    }

    return '';
  };

  return (
    <>
      <ProviderTitle>
        {intl.formatMessage({ id: 'custom-providers.settings.email.provider.smtp.label' })}
      </ProviderTitle>
      <ProviderSubtitle>
        {intl.formatMessage(
          { id: 'custom-providers.settings.email.provider.smtp.description' },
          {
            a: (chunk: string) => <DescriptionLink href="">{chunk}</DescriptionLink>
          }
        )}
      </ProviderSubtitle>
      <FieldWrapper>
        <Notification icon={AlertExclamation}>
          {intl.formatMessage(
            { id: 'custom-providers.settings.email.provider.smtp.notification' },
            {
              ul: (chunk: string) => (
                <ul style={{ padding: '0 0 0 24px', margin: '0' }}>{chunk}</ul>
              ),
              li: (chunk: string) => <li>{chunk}</li>
            }
          )}
        </Notification>
      </FieldWrapper>
      <FieldWrapper>
        <FieldInput
          label={intl.formatMessage({
            id: 'custom-providers.settings.email.provider.smtp.host.label'
          })}
          placeholder={intl.formatMessage({
            id: 'custom-providers.settings.email.provider.smtp.host.placeholder'
          })}
          subLabel={intl.formatMessage({
            id: 'custom-providers.settings.email.provider.smtp.host.sublabel'
          })}
          name="provider_settings.host"
          errorMessage={getError('host')}
        />
      </FieldWrapper>
      <FieldWrapper>
        <FieldInput
          label={intl.formatMessage({
            id: 'custom-providers.settings.email.provider.smtp.port.label'
          })}
          placeholder={intl.formatMessage({
            id: 'custom-providers.settings.email.provider.smtp.port.placeholder'
          })}
          subLabel={intl.formatMessage(
            {
              id: 'custom-providers.settings.email.provider.smtp.port.sublabel'
            },
            {
              br: () => <br />
            }
          )}
          name="provider_settings.port"
          errorMessage={getError('port')}
        />
      </FieldWrapper>
      <FieldWrapper>
        <FieldInput
          label={intl.formatMessage({
            id: 'custom-providers.settings.email.provider.smtp.username.label'
          })}
          placeholder={intl.formatMessage({
            id: 'custom-providers.settings.email.provider.smtp.username.placeholder'
          })}
          name="provider_settings.username"
          errorMessage={getError('username')}
        />
      </FieldWrapper>
      <FieldWrapper>
        <FieldInput
          label={intl.formatMessage({
            id: 'custom-providers.settings.email.provider.smtp.password.label'
          })}
          placeholder={intl.formatMessage({
            id: 'custom-providers.settings.email.provider.smtp.password.placeholder'
          })}
          name="provider_settings.password"
          errorMessage={getError('password')}
        />
      </FieldWrapper>
    </>
  );
};
